import { render, staticRenderFns } from "./deleteFile.vue?vue&type=template&id=8597a328"
import script from "./deleteFile.vue?vue&type=script&lang=js"
export * from "./deleteFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports